<template>
    <div>
        <v-data-table
            dense
            v-model="selected"
            :items="data"
            :options="options"
            @update:options="$emit('update:options', $event)"
            :loading="loading"
            :server-items-length="length"
            show-select
            single-select
            :page="page"
            @update:page="$emit('update:page', $event)"
            @item-selected="setSelectedFromCheckbox"
            @click:row="setSelected"
            @dblclick:row="openPaymentDisplayDialog"
            @contextmenu:row="openContextMenu"
            :footer-props="{ 'items-per-page-options': [5,10,15] }"
            :headers="headers"
            :disable-pagination="!pagination"
            :hide-default-footer="!pagination"
            >
                <template v-slot:[`item.created_at`]="{ item }">
                    {{ moment(item.created_at).format('YYYY-MM-DD') }}
                </template>
                <template v-slot:[`item.amount`]="{item}">
                    <p-amount :amount="item.amount" :currancy="item.currency"></p-amount>
                </template>
                <template v-slot:[`item.state`]="{ item }">
                    <p-status :state="item.state"></p-status>
                </template>

        </v-data-table>
        <context-menu
            v-if="contextMenu.display"
            :position="contextMenu.position"
            :items="contextMenuItems"
            @contextmenu:click="contextMenuClicked">
        </context-menu>
        <payment-display-dialog
            ref="paymentDisplayDialog"
            v-on="$listeners">
        </payment-display-dialog>
        <incoming-payment
            v-if="incomingPayment.display"
            :id="incomingPayment.id"
            @update="$emit('updated', options)"
            @close="incomingPayment.display = false">
        </incoming-payment>
        <delete-single-dialog
            @submit="onDeleteDialogSubmit"
            ref="deleteSingleDialog">

        </delete-single-dialog>
    </div>
</template>

<script>
import {formatMoney} from 'accounting';
import { mapActions, mapState } from 'vuex'
import accounting from 'accounting';

import getColor from '@/utils/getColor';

import DeleteSingleDialog from '../common/DeleteSingleDialog.vue'
import IncomingPayment from '../accounting/IncomingPayment.vue'
import ContextMenu from '../common/ContextMenu.vue'
import PaymentDisplayDialog from './PaymentDisplayDialog.vue';
import PStatus from '../common/PStatus.vue';
import PAmount from '../common/PAmount.vue';
import moment from 'moment';
// import { getPaymentsList } from '../../services/sales/payment';
// import { getPaymentsList } from '../../services/sales/payment';

export default {
    name:'PaymentDataTable',
    components: {
        ContextMenu,
        PaymentDisplayDialog,
        IncomingPayment,
        DeleteSingleDialog,
        PStatus,
        PAmount
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        customerId: {
            type: Number,
            required: false
        },
        length: {
            type: Number,
            required: false
        },
        loading: {
            type: Boolean,
            required: true
        },
        pagination: {
            type: Boolean,
            required: true
        },
        query: {
            type: Object,
            required: true
        },
        page: Number,
        options: Object
    },
    data() {
        return {
            incomingPayment: {
                id: null,
                display: false
            },
            contextMenu: {
                display: false,
                position: {
                    x: 0,
                    y: 0,
                }
            },
            selected: [],
            headers:[
                { text: this.$t('code_'), value: "code" },
                { text: this.$t('date'), value: "created_at" },
                { text: this.$t('document_date'), value: "date" },
                { text: this.$t('customer'), sortable: false, value: "customer" },
                { text: this.$t('mode'), sortable: false, value: "payment_mode" },
                { text: this.$t('amount'), value: "amount", sortable: false },
                { text: this.$t('state'), value: 'state' }
            ],
        }
    },
    computed: {
        ...mapState('authentication', ["authorizations"]),
        contextMenuItems() {
            return [
                { title: this.$t("show"), icon: "mdi-eye", action: "openPaymentDisplayDialog", disabled: !this.authorizations.payments.read},
                { title: this.$t("edit"), icon: "mdi-pencil", action: "openIncomingPayment", disabled: !this.isEditable},
                { title: this.$t("delete"), icon: "mdi-delete", action: "openDeleteSingleDialog", disabled: !this.isDeletable}
            ]
        },
        isDeletable() {
            if(!this.getSelected.meta) return false;
            else return this.getSelected.meta.deletable && this.authorizations.payments.delete
        },
        isEditable() {
            if(!this.getSelected.meta) return false;
            else return this.getSelected.meta.editable && this.authorizations.payments.update
        },
        getSelected() {
            return this.selected.length == 1 ? this.selected[0] : {};
        }
    },
    methods: {
        formatMoney,
        moment,
        getColor,
        fetchPaymentData() {
            // getPaymentsList()
        },
        formatNumber(number) {
            return accounting.formatMoney(number, "SDG ", 2);
        },
        ...mapActions("sales/payment",["removePayment"]),
        pushSelected(payment) {
            this.selected.push(payment);
            this.$emit("selected:row", [payment]);
        },
        clearSelected() {
            this.selected = [];
        },
        setSelected(payment) {
            this.clearSelected();
            this.pushSelected(payment);
        },
        setSelectedFromCheckbox({value, item}) {
            if(value) this.setSelected(item);
            else this.$emit("selected:clear");
        },
        openPaymentDisplayDialog() {
            this.$refs.paymentDisplayDialog.open({id: this.getSelected.id});
        },
        openInvoiceEditDialog() {
            this.invoiceDialog.display = true;
        },
        openDeleteSingleDialog() {
            this.$refs.deleteSingleDialog.open({target: "payment", id: this.getSelected.id});
        },
        openContextMenu(e, payload) {
            e.preventDefault();
            this.contextMenu.position.x = e.clientX
            this.contextMenu.position.y = e.clientY
            this.contextMenu.display = false;
            this.$nextTick(() => {
                this.contextMenu.display = true;
            });
            this.setSelected(payload.item);
        },
        contextMenuClicked(action) {
            this[action]();
        },
        onDeleteDialogSubmit(params) {
            if(params.target == 'payment') {
                this.removePayment(params)
                    .then(() => {
                        this.$refs.deleteSingleDialog.close();
                        this.clearSelected();
                        this.$emit("updated");
                        this.$refs.alertDialog.open({type: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.$refs.deleteSingleDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            }
        },
        openIncomingPayment(){
            this.incomingPayment.id = this.getSelected.id;
            this.incomingPayment.display = true;
        },
    },
    created(){

    }
}
</script>

<style>

</style>